document.addEventListener('DOMContentLoaded', function() {
  const navItems = document.querySelectorAll('.specification-nav li');
  const contentItems = document.querySelectorAll('.specification-item');

  function activateTab(tabId) {
    navItems.forEach(function(item) {
      const itemId = item.getAttribute('data-id');
      if (itemId === tabId) {
        item.classList.add('active');
      } else {
        item.classList.remove('active');
      }
    });

    contentItems.forEach(function(content) {
      const contentId = content.getAttribute('data-id');
      if (contentId === tabId) {
        content.classList.add('active');
      } else {
        content.classList.remove('active');
      }
    });
  }

  navItems.forEach(function(item) {
    const link = item.querySelector('a');
    const tabId = item.getAttribute('data-id');

    link.addEventListener('click', function(e) {
      e.preventDefault();
      activateTab(tabId);
      history.pushState(null, null, link.getAttribute('href'));
    });
  });

  if (navItems.length > 0) {
    const firstTabId = navItems[0].getAttribute('data-id');
    activateTab(firstTabId);
  }

  const hash = window.location.hash.substring(1);
  if (hash) {
    const matchingNav = Array.from(navItems).filter(function(item) {
      return item.getAttribute('data-id') === hash;
    })[0];
    if (matchingNav) {
      activateTab(hash);
    }
  }
});
